import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatCheckbox} from '@angular/material/checkbox';
import {ElevatedButtonComponent} from '@aviary/buttons/elevated-button/elevated-button.component';
import {ActionButtonsComponent} from '@aviary/components/action-buttons/action-buttons.component';
import {ComponentLibSectionComponent} from '@aviary/components/component-lib/section/component-lib-section.component';

@Component({
  selector: 'mx-component-lib-checkboxes',
  templateUrl: './component-lib-checkboxes.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ActionButtonsComponent, ComponentLibSectionComponent, ElevatedButtonComponent, MatCheckbox]
})
export class ComponentLibCheckboxesComponent {
  public allCheckboxesDisabled: boolean = false;
  public allCheckboxesChecked: boolean = false;
}
